import { useState } from 'react';
import { endpoints } from '../../api';
import { uiText } from '../../i18n';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import { clearPhotoResult, readPhotoResult } from './photo-result-entry';
/** Импорт инициирует человек: права, владелец и неизменённая версия источника проверяются перед upload. */
export function PhotoResultImport({ state }: { state: CircleFormState }) {
  const [error, setError] = useState('');
  const entry = readPhotoResult();
  const photoFields = state.form?.fields.filter(item => item.upload?.kind === 'photo' && item.upload?.purpose !== 'reference') ?? [];
  const field = photoFields[0];
  if (!entry || !field || state.form?.screen !== entry.destination || state.orderId)
    return error ? <p role="alert">{uiText(error)}</p> : null;
  return (
    <div className="photo-result-import">
      <button
        type="button"
        disabled={state.locked || !state.rights}
        onClick={async () => {
          try {
            const me = await endpoints.me();
            if (me.user.id !== entry.owner) {
              clearPhotoResult(entry);
              throw new Error('owner_changed');
            }
            const source = await endpoints.speech.get(entry.orderId);
            if (
              source.status !== 'done' ||
              !source.result?.available ||
              source.result_revision !== entry.revision ||
              ![entry.index, ...(entry.extra ?? []).map(item => item.index)].every(index =>
                source.result!.assets.some(asset => asset.index === index),
              )
            )
              throw new Error('source_changed');
            // Несколько кадров — в свободные слоты фото по порядку; лишние не загружаются.
            const files = [entry.file, ...(entry.extra ?? []).map(item => item.file)];
            const free = photoFields.filter(item => !state.inputs[item.key] && !state.uploadIds?.[item.key]);
            let ok = true;
            for (const [index, file] of files.slice(0, Math.max(1, free.length)).entries())
              ok = (await state.upload((free[index] ?? field).key, file)) === true && ok;
            if (ok) clearPhotoResult(entry);
            setError('');
          } catch {
            setError('Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.');
          }
        }}
      >
        {uiText(entry.extra?.length ? 'Использовать выбранные фото результата' : 'Использовать выбранное фото результата')}
      </button>
      {error && <p role="alert">{uiText(error)}</p>}
    </div>
  );
}
